import type { TFunction } from 'i18next';

import type { SeoCopy } from './seo-summary';

/** The page count line: each count may be one or (for the descriptions) none, so each case has its own key. */
const pagesLine = (t: TFunction, n: number, m: number): string => {
  if (m === 0)
    return n === 1 ? t('1 page · none without a description') : t('{{n}} pages · none without a description', { n });
  if (n === 1)
    return m === 1 ? t('1 page · 1 without a description') : t('1 page · {{m}} without a description', { m });
  return m === 1
    ? t('{{n}} pages · 1 without a description', { n })
    : t('{{n}} pages · {{m}} without a description', { n, m });
};

/**
 * The SEO card's copy: one literal `t()` key per id, so the extractor harvests every one; the `switch` is exhaustive,
 * so a new id fails the typecheck until it has its copy.
 */
export const seoCopy = (t: TFunction, c: SeoCopy): string => {
  switch (c.id) {
    case 'unpublished-changes':
      return t('Unpublished changes');
    case 'publishing':
      return t('Publishing…');
    case 'not-on-site':
      return t('Not on your site yet');
    case 'pages':
      return pagesLine(t, c.n, c.m);
    case 'seo-unavailable':
      return t("SEO isn't available yet");
    case 'not-set-up':
      return t("SEO isn't set up yet");
    case 'open-seo':
      return t('Open SEO');
    case 'review-and-publish':
      return t('Review and publish');
  }
};
